import { Injectable, TemplateRef } from '@angular/core';
import {
    BehaviorSubject, fromEvent, map, startWith,
} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BreakpointService {
    /**
     * Wheter screensize is above tailwinds breakpoint for sm
     */
    sm = new BehaviorSubject<boolean>(false);

    /**
     * Wheter screensize is above tailwinds breakpoint for md
     */
    md = new BehaviorSubject<boolean>(false);

    /**
     * Wheter screensize is above tailwinds breakpoint for lg
     */
    lg = new BehaviorSubject<boolean>(false);

    /**
     * Wheter screensize is above tailwinds breakpoint for xl
     */
    xl = new BehaviorSubject<boolean>(false);

    /**
     * Wheter screensize is above tailwinds breakpoint for 2xl
     */
    '2xl' = new BehaviorSubject<boolean>(false);

    /**
     * Wheter screensize is above tailwinds breakpoint for 3xl
     */
    '3xl' = new BehaviorSubject<boolean>(false);

    /**
     * Reference to a template to render at bottom of page
     */
    templateRef?: TemplateRef<any>;

    constructor() {
        // track window resize events and match current window size with tailwind breakpoints
        fromEvent(window, 'resize').pipe(
            startWith(null),
            map(() => window.innerWidth),
        ).subscribe((size) => {
            // Predefined tailwind screen sizes. These should match tailwind.config.js
            const screens = {
                'sm': '640px',
                'md': '768px',
                'lg': '1024px',
                'xl': '1280px',
                '2xl': '1536px',
                '3xl': '1792px',
            };
            for (const [key, value] of Object.entries(screens)) {
                // emit all booleans to the tailwind breakpoints
                if ((this as any)[key].value !== (size >= parseFloat(value))) {
                    (this as any)[key].next(size >= parseFloat(value));
                }
            }
        });
    }
}
